import { LitElement, html } from 'lit';
import Styles from './vm-sort-dropdown.scss';

export default class VmSortDropdown extends LitElement {
    static styles = Styles;
    static properties = {
        currentSortObject: { state: true },
        options: { type: Array },
        menuOpen: { state: true },
    };

    handleSortChange(option) {
        this.currentSortObject = option;

        this.dispatchEvent(
            new CustomEvent('vm-sort-change', {
                detail: { sortObject: option },
                bubbles: true,
                composed: true,
            }),
        );

        this.toggleDropdownMenu();
    }

    renderSortingOption(option) {
        return html`
            <button
                class="dropdown__menu-item"
                data-param="${option.param}"
                @click=${() => this.handleSortChange(option)}
            >
                ${option.label}
            </button>
        `;
    }

    toggleDropdownMenu() {
        this.menuOpen = !this.menuOpen;
    }

    constructor() {
        super();
        this.menuOpen = false;
        this.options = [];
        this.currentSortObject = null;
    }

    willUpdate(changed) {
        if (changed.has('options') && !this.currentSortObject) {
            this.currentSortObject = this.options?.[0] ?? null;
        }
    }

    render() {
        return html`
            <div class="dropdown">
                <button
                    class="vm-button vm-button--xs vm-button--secondary vm-button--sort-dropdown"
                    @click=${this.toggleDropdownMenu}
                >
                    <span>${this.currentSortObject?.label ?? ''}</span>
                    <i class="icon icon-chevron-down"></i>
                </button>
                <div
                    class="dropdown__menu dropdown__menu--right ${this.menuOpen ? '' : 'is-hidden'}"
                    aria-labelledby="sort-dropdown"
                >
                    ${this.options.map((option) => this.renderSortingOption(option))}
                </div>
            </div>
        `;
    }
}
